// JS
import '../../custom/js/index';

// Base SCSS
import '../../custom/scss/base.scss';

// Pages
import '../../custom/scss/pages/sitemap.scss';
